import { DefaultTheme } from '../../components/theme';
import { CSS as CaptureThumbnailCSS } from '../capture.thumbnail/capture.thumbnail.style';

export const CSS = {
	container: 'c-CaptureBar',
};

export const THUMBNAIL_SIZE = 100;

export const Style = {
	[CSS.container]: {
		padding: DefaultTheme.space(2),
		display: 'flex',
		'flex-direction': 'column',
		width: THUMBNAIL_SIZE + DefaultTheme.spacingFactor * 2,
		'align-items': 'center',
		'overflow-x': 'hidden',
		'overflow-y': 'auto',
		'border-left': `1px solid ${DefaultTheme.font.color.divider}`,
		'border-right': `1px solid ${DefaultTheme.font.color.divider}`,
		[`& .${CaptureThumbnailCSS.container}`]: {
			margin: `${DefaultTheme.space(1)} 0`,
			width: `${THUMBNAIL_SIZE}px`,
			height: `${THUMBNAIL_SIZE}px`,
			'min-width': `${THUMBNAIL_SIZE}px`,
			'min-height': `${THUMBNAIL_SIZE}px`,
		},
		[`& .${CaptureThumbnailCSS.container}:hover`]: {
			border: `${DefaultTheme.space(1)} solid ${DefaultTheme.color.accent}`,
		},
	},
};
